import { render, staticRenderFns } from "./settings-company-notifications.vue?vue&type=template&id=571d946b&"
import script from "./settings-company-notifications?vue&type=script&lang=ts&"
export * from "./settings-company-notifications?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports